import PosCartStore from '../../stores/PosCartStore';
class Price extends React.Component {

    render() {
        const { allowHidden } = this.props;
        var price   = parseFloat(this.props.price).toFixed(2);
        var dollar  = this.props.dollar;
        
        if (!PosCartStore.getCartSummary().StatefulCheckoutTotalCalculated && allowHidden) {
            price = '-';
            dollar = false;
        } else if (price > 999.99) {
            var price = price.split('.');
            switch (price[0].length)
            {
                case 4:
                    price = price[0][0]+','+price[0][1]+''+price[0][2]+''+price[0][3]+'.'+price[1];
                    break;

                case 5:
                    price = price[0][0]+''+price[0][1]+','+price[0][2]+''+price[0][3]+''+price[0][4]+'.'+price[1];
                    break;

                case 6:
                    price = price[0][0]+''+price[0][1]+''+price[0][2]+','+price[0][3]+''+price[0][4]+''+price[0][5]+'.'+price[1];
                    break;
            }
        }

        return (
            <div className={'price '+this.props.className}>
                {(dollar ? '$' : '')} {price}
            </div>
        );

    }
}

export default Price;


// WEBPACK FOOTER //
// ./ui_src/app/components/form/Price.react.jsx